import { produce } from "immer";
export const initialState = {
    past: [],
    current: { type: "NONE" },
    future: [],
};
export const extractedFilesReducer = (state, action) => {
    switch (action.type) {
        case "RESET":
            return {
                past: [],
                current: { type: "NONE" },
                future: [],
            };
        case "ACTION_ADDED":
            return produce(state, (draftState) => {
                if (draftState.current.type === "NODE" &&
                    action.payload.type === "NODE" &&
                    draftState.current.id === action.payload.id)
                    return;
                if (draftState.current.type === "LINK" &&
                    action.payload.type === "LINK" &&
                    draftState.current.source === action.payload.source &&
                    draftState.current.target === action.payload.target)
                    return;
                draftState.past.unshift(state.current);
                draftState.current = action.payload;
            });
        case "UNDO":
            return produce(state, (draftState) => {
                if (draftState.past.length > 0) {
                    draftState.future.push(state.current);
                    const current = draftState.past.shift();
                    draftState.current = current ? current : { type: "NONE" };
                }
                else
                    return state;
            });
        case "REDO":
            return produce(state, (draftState) => {
                if (draftState.future.length > 0) {
                    draftState.past.push(state.current);
                    const current = draftState.future.shift();
                    draftState.current = current ? current : { type: "NONE" };
                }
                else
                    return state;
            });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map